import * as React from 'react';
import './AccountStatementFooter.scss';

export function AccountStatementFooter(props: any) {
  const { t } = props;
  return (
    <div className="rp-account-statement--footer">
      <span>{t('accountMonthlyStatements.statementPageDisclaimerTxt')}</span>
    </div>
  );
}
